// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__32rR9","error":"InputSecondary_error__1XT5z","disabled":"InputSecondary_disabled__3vygF"};